import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { AssetLogDirection } from './assetLogContent.utils';
import styles from '~/app/components/asset-detail/AssetLogsTable/AssetLogsTable.module.css';

type Props = {
  direction: AssetLogDirection | null;
};

export function AssetLogDirectionLabel({ direction }: Props) {
  const { t } = useTranslation('assets');

  if (!direction) {
    return <span className={styles.detailValue}>—</span>;
  }

  if (direction === 'inbound') {
    return (
      <span className={`${styles.direction} ${styles.directionInbound}`}>
        <ArrowLeftOutlined aria-hidden />
        <span>{t('detail.logs.direction.inbound', 'Inbound')}</span>
      </span>
    );
  }

  return (
    <span className={`${styles.direction} ${styles.directionOutbound}`}>
      <ArrowRightOutlined aria-hidden />
      <span>{t('detail.logs.direction.outbound', 'Outbound')}</span>
    </span>
  );
}
